import { AssessmentAuthenticationField } from '../types';

const HEADER_PREFIX = 'Enter your';
const HEADER_SUFFIX = 'to get started';

/**
 * Formats an array of strings into a grammatically correct list.
 * Examples:
 * - [] -> "information"
 * - ["email"] -> "email"
 * - ["date of birth", "email"] -> "date of birth and email"
 * - ["date of birth", "email", "member id"] -> "date of birth, email, and member id"
 */
const formatLabelList = (labels: string[]): string => {
  if (labels.length === 0) return 'information';
  if (labels.length === 1) return labels[0];
  if (labels.length === 2) return `${labels[0]} and ${labels[1]}`;
  return `${labels.slice(0, -1).join(', ')}, and ${labels[labels.length - 1]}`;
};

/**
 * Generates header text from field labels.
 * Examples:
 * - 1 field: "Enter your email address to get started"
 * - 2 fields: "Enter your date of birth and email address to get started"
 * - 3+ fields: "Enter your date of birth, email address, and member id to get started"
 */
export const generateHeaderText = (fields: AssessmentAuthenticationField[]): string => {
  const labels = fields.map((field) => field.label.toLowerCase());
  return `${HEADER_PREFIX} ${formatLabelList(labels)} ${HEADER_SUFFIX}`;
};
